module.exports = __webpack_public_path__ + "static/img/logo.fa5e55b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 13